import {
  useAddChatMessageMutation,
  useGetChatMessagesQuery,
} from '../api/chat.api'

const useChatMessages = (chatId: string) => {
  const { data, isError, isLoading, isSuccess } =
    useGetChatMessagesQuery(chatId)

  const [addChatMessage, addChatMessageMutationStatus] =
    useAddChatMessageMutation()

  return {
    messages: data?.records?.filter(({ message }) => !!message),
    addChatMessage,
    addChatMessageMutationStatus,
    getMessagesStatus: {
      isError,
      isLoading,
      isSuccess,
    },
  }
}

export default useChatMessages
